/**
 * Brand type for creating nominal types in TypeScript.
 * Allows creating distinct types from the same underlying type to prevent mixing them.
 *
 * @example
 * type UserId = Brand<string, 'UserId'>;
 * type ProductId = Brand<string, 'ProductId'>;
 *
 * const userId: UserId = 'user-123' as UserId;
 * const productId: ProductId = 'prod-456' as ProductId;
 * // These cannot be assigned to each other despite both being strings
 */
export type Brand<T, TBrand = symbol> = { __brand__: TBrand } & T

export type Expand<T> = T extends infer O ? { [K in keyof O]: O[K] } : never

export type XOR<T, U> =
  | ({ [K in Exclude<keyof T, keyof U>]?: never } & U)
  | ({ [K in Exclude<keyof U, keyof T>]?: never } & T)
